import ls from './local-storage/ls';
import css from './csstool/csstool';
import dom from './dom/dom';
import http from './http/http';
import tool from './tool/tool';
// import oss from './oss/oss';
import Event from './event/class';
import buildPrint from './print';
import * as date from './date/index';
import * as getlibs from './get-libs';

export default {
  ls,
  css,
  dom,
  http,
  tool,
  // oss,
  Event,
  buildPrint,
  date,
  getlibs,
};
